import clsx from 'clsx'
import map from 'lodash/map'
import React from 'react'

import CheckSVG from '@Assets/SVG/Check'
import PlusSVG from '@Assets/SVG/Plus'
import { BuyButtonV2 } from '@Components/BuyButton/v2'
import { ProductItem } from '@Domains/Product/Components/ProductItem'
import { AddToCartPromptSuccessTacticFragmentFragment, Maybe } from '@Generated/graphql'
import { MetadataContext } from '@Globals/Metadata'

import styles from './AddToCartPromptSuccess.module.scss'

type TacticWithRecommendations = Extract<AddToCartPromptSuccessTacticFragmentFragment, { recommendations?: Maybe<Array<{ __typename?: 'Recommendation' }>> }>

export const AddToCartPromptSuccessRecommendations = ({
  tactic,
}: {
  tactic: TacticWithRecommendations
}) => {
  const { storeURL } = React.useContext(MetadataContext)
  const [addedIds, setAddedIds] = React.useState<string[]>([])

  if (!tactic.recommendations || tactic.recommendations.length === 0) {
    return null
  }

  const recommendationID = tactic.recommendations[0].id

  return (
    <div className={styles.recommendations}>
      <div className={styles.recommendationsTitle}>{tactic.recommendations[0].title}</div>
      {map(tactic.recommendations[0].products, product => (
        <ProductItem
          key={product.id}
          action={(
            <BuyButtonV2
              className={clsx(styles.AddToCartProduct, addedIds.includes(product.id) && styles.success)}
              color="black"
              onSuccess={() => {
                setAddedIds(prev => [...prev, product.id])
              }}
              preventDefault
              productID={product.id}
              products={[{ quantity: 1, variantID: '', productID: product.id }]}
              sourceID={`add_to_cart_${recommendationID}`}
              stopPropagation
              useCache={false}
              withoutSuccessPrompt
            >
              {!addedIds.includes(product.id) ? <PlusSVG /> : <CheckSVG />}
            </BuyButtonV2>
          )}
          analytics={{ source_id: 'add_to_cart_bought_together' }}
          className={styles.recommendationsProduct}
          content={product.name}
          discount={product.masterVariant?.price?.discount?.format || ''}
          imageUrl={product.primaryAsset?.url || ''}
          price={product.masterVariant?.price?.format || ''}
          url={storeURL(product.url || '')}
        />
      ))}
    </div>
  )
}
